import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ chapter, eyebrow, title, text, align = "left", testid, hint }) => (
  <div className={align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} data-testid={testid}>
    <Reveal>
      <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-wood">
        {chapter && <span className="font-serif text-2xl italic text-taupe">{chapter}</span>}
        <span className={`h-px w-10 bg-taupe/50 ${align === "center" ? "hidden" : ""}`} />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-ink leading-[1.08]">{title}</h2>
    </Reveal>
    {text && (
      <Reveal delay={0.2}>
        <p className="mt-6 text-base leading-relaxed text-moss">{text}</p>
      </Reveal>
    )}
    {hint && <ScrollHint testid={hint} />}
  </div>
);

export const ScrollHint = ({ testid, light = false }) => (
  <div className="mt-7 flex items-center gap-2.5 lg:hidden" data-testid={testid}>
    <span className={`text-[11px] font-semibold uppercase tracking-[0.25em] ${light ? "text-ivory/70" : "text-taupe"}`}>Scorri</span>
    <motion.span animate={{ x: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 1.6, ease: "easeInOut" }} className="text-terracotta">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
    </motion.span>
    <span className={`h-px flex-1 ${light ? "bg-ivory/25" : "bg-sand"}`} />
  </div>
);
